import { FaChevronDown, FaChevronUp, FaXmark } from 'react-icons/fa6';
import { useState } from 'react';

interface AccordionProps {
    name: string;
    price: number;
    numberOfTicket: number;
    recurringEntry: number;
    highlight?: string;
    onDelete: (e?: React.MouseEvent) => void;
    disabled?: boolean;
}

const AccordionPackage: React.FC<AccordionProps> = ({
    name,
    price,
    numberOfTicket,
    recurringEntry,
    highlight,
    onDelete,
    disabled = false
}) => {
    const [isOpen, setIsOpen] = useState(false);
    // Note: Tier-level draw linking has been removed. Draw selection is handled at the
    // membership level in CreatePackage. This avoids unnecessary admin API calls when
    // expanding the accordion and prevents redirects if auth has expired.

    return (
        <div className="mb-3 border border-gray-200 rounded-xl overflow-hidden">
            <div 
                className="flex items-center justify-between p-4 cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="flex items-center justify-between flex-1 mr-4">
                    <div>
                        <h3 className="font-medium text-primary">{name}</h3>
                        <p className="text-sm text-gray-600">AUD {price}</p>
                    </div>
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onDelete(e);
                    }}
                    disabled={disabled}
                    className={`p-2 rounded-lg transition-colors duration-200 ${
                        disabled 
                            ? 'text-gray-300 cursor-not-allowed' 
                            : 'text-gray-400 hover:text-red-500 hover:bg-gray-200'
                    }`}
                >
                    <FaXmark className="w-4 h-4" />
                </button>
            </div>

            {isOpen && (
                <div className="p-4 bg-white">
                    <div className="space-y-4">
                        {/* Tier Details */}
                        <div className="space-y-2">
                            <div className="flex justify-between">
                                <span className="text-gray-600">Number of Tickets:</span>
                                <span className="font-medium">{numberOfTicket}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-gray-600">Recurring Entry:</span>
                                <span className="font-medium">{recurringEntry}</span>
                            </div>
                            {highlight && (
                                <div className="flex justify-between">
                                    <span className="text-gray-600">Highlight:</span>
                                    <span className="font-medium">{highlight}</span>
                                </div>
                            )}
                        </div>
                        {/* Note: Linked draws UI removed; draw selection is now membership-level only. */}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AccordionPackage;
